const prefix = "partcipantDashboard";

export const SET_STUDY_ID = `${prefix}/SET_STUDY_ID`;
export const SET_COMPLETION = `${prefix}/SET_COMPLETION`;
export const SET_COMPLETION_PARTICIPANT = `${prefix}/SET_COMPLETION_PARTICIPANT`;
export const SET_SITE_LIST_IN_PARTICIPANTS = `${prefix}/SET_SITE_LIST_IN_PARTICIPANTS`;
export const SET_ECONSENT_RAW_DATA = `${prefix}/SET_ECONSENT_RAW_DATA`;
export const SET_ECONSET_DISPOSITION_DATA = `${prefix}/SET_ECONSET_DISPOSITION_DATA`;
export const SET_CONSENT_BLOCKS = `${prefix}/SET_CONSENT_BLOCKS`;

export const SET_COUNTRIES = `${prefix}/SET_COUNTRIES`
export const SET_SITES = `${prefix}/SET_SITES`
export const SET_COUNTRY_SELECTED = `${prefix}/SET_COUNTRY_SELECTED`
export const SET_SITES_SELECTED = `${prefix}/SET_SITES_SELECTED`
export const SET_FILTER_FROM_DATE = `${prefix}/SET_FILTER_FROM_DATE`
export const SET_FILTER_TO_DATE = `${prefix}/SET_FILTER_TO_DATE`
export const SET_IGNORE_CACHE = `${prefix}/SET_IGNORE_CACHE`
export const SET_PARTICIPANTS_SELECTED = `${prefix}/SET_PARTICIPANTS_SELECTED`

export const SET_SPECIFIC_SITE_ID = `${prefix}/SET_SPECIFIC_SITE_ID`

export default prefix;